import { Controller } from "@hotwired/stimulus"

/**
 * Image loader controller
 * Shows a loader while the image is loading
 */
export default class extends Controller {
  static targets = ["image", "loader"]
  
  connect() {
    // Hide all images initially
    this.imageTargets.forEach(image => {
      image.style.display = "none"
      
      // Set up event listener for when image loads
      image.addEventListener("load", this.imageLoaded.bind(this, image))
      
      // If the image is already cached and loaded
      if (image.complete) {
        this.imageLoaded(image)
      }
    })
  }
  
  imageLoaded(image) {
    // Find the loader that corresponds to this image
    const loaderIndex = this.imageTargets.indexOf(image)
    const loader = this.loaderTargets[loaderIndex]
    
    // Hide the loader and show the image with a fade-in effect
    if (loader) {
      loader.style.display = "none"
    }
    
    // Show the image
    image.style.display = "block"
    image.classList.add("opacity-100")
  }
} 
